import { useState } from "react";
import { useSelector } from "react-redux";

export const useProjectGalleryHeader = () => {
  const [isSelected, setIsSelected] = useState(false);
  const [clearModal, setClearModal] = useState(false);

  const { selectedImageListView, status, currentFolderDetails, isClearing } =
    useSelector((state) => state.gallery);
  const { allFolders } = useSelector((state) => state.projectSinglePage);

  const {
    getCurrentProjectDetails,
    postShareStatus,
    notifyData,
    ulockStatus,
    unlockMessage,
  } = useSelector((state) => state.projectSinglePage);
  const { tokenDetails } = useSelector((state) => state.FPAupload);
  const { sections, currentTab } = useSelector((state) => state.gallery);
  const { project } = useSelector((state) => state);

  const handleClearModal = () => {
    setClearModal(!clearModal);
  };

  return {
    selectedImageListView,
    status,
    currentFolderDetails,
    isClearing,
    allFolders,
    getCurrentProjectDetails,
    postShareStatus,
    notifyData,
    ulockStatus,
    unlockMessage,
    tokenDetails,
    sections,
    currentTab,
    project,
    isSelected,
    setIsSelected,
    clearModal,
    setClearModal,
    handleClearModal,
  };
};
